import { render, staticRenderFns } from "./update-edit.vue?vue&type=template&id=20573c8c&scoped=true"
import script from "./update-edit.vue?vue&type=script&lang=js"
export * from "./update-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20573c8c",
  null
  
)

export default component.exports